import React from 'react'
import { css as hcss } from '@emotion/css'

type Props = {
  selected?: boolean
  selectable?: boolean
  text: string
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const tag = hcss`
border : solid 2px black; 
border-radius : 10px;
padding : 15px;
display: flex ; 
align-items : center; 
background-color : white;
margin : 10px ;
`

const checkbox = hcss`

`
export default ({ value, selected, selectable, text, onChange }: Props) => {
  return (
    <div className={tag}>
      {selectable ? (
        <input
          value={value}
          type="checkbox"
          className={checkbox}
          defaultChecked={selected}
          onChange={onChange}
        />
      ) : (
        <></>
      )}
      <label htmlFor={value} style={{ fontFamily: 'Montserrat-Regular' }}>
        {text}
      </label>
    </div>
  )
}
